module.exports = __webpack_public_path__ + "img/record.26fb68c3.svg";